import { Box } from "@mui/material";
import SectionCollapsible from "../../../common/SectionCollapsible";
import SectionFields from "../tabs/common/Section/SectionFields";
import { buildBenefitsFields } from "../fields/benefits";
import type { Pillars } from "../../types";

export function ReadOnlyBenefitsContainer({ pillars }: { pillars?: Pillars }) {
  return (
    <Box data-testid="read-only-benefits-container">
      <SectionCollapsible label="Benefits">
        <SectionFields
          fields={buildBenefitsFields(pillars)}
          columns={2}
          fieldIdPrefix="read-only-benefits"
          highlightMissingFields={false}
        />
      </SectionCollapsible>
    </Box>
  );
}

export default ReadOnlyBenefitsContainer;
